import { Component, Injector, OnInit } from "@angular/core";
import { BaseComponent } from "../../base.component";

@Component({
  selector: "break",
  template: `
    hfgh
  `,
  styleUrls: ["./break.component.scss"]
})
export class BreakComponent extends BaseComponent implements OnInit {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {}
}
